import { cn } from "@/lib/utils/cn";
import { generateSkeletonArray } from "@/lib/utils/skeletonUtils";
import { SkeletonBase } from "./SkeletonBase";

/**
 * List skeleton loader
 * @param {Object} props - Component props
 * @param {number} [props.items=5] - Number of list items to display
 * @param {boolean} [props.hasAvatar=false] - Whether to show avatar skeleton
 * @param {boolean} [props.hasTwoLines=true] - Whether to show two lines per item
 * @param {string} [props.className] - Additional CSS classes
 */
export function ListSkeleton({ items = 5, hasAvatar = false, hasTwoLines = true, className }) {
  const itemArray = generateSkeletonArray(items);

  return (
    <div className={cn("space-y-4", className)}>
      {itemArray.map((index) => (
        <div key={`list-item-${index}`} className="flex items-center gap-4">
          {/* Avatar skeleton */}
          {hasAvatar && <SkeletonBase variant="avatar" />}

          {/* Content skeleton */}
          <div className="flex-1 space-y-2">
            <SkeletonBase variant="line" className="w-3/4" />
            {hasTwoLines && <SkeletonBase variant="line" className="w-1/2" />}
          </div>
        </div>
      ))}
    </div>
  );
}
